/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { CreatePoFilePurchaseRequest, PurchaseRequestDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiPurchaseOrderFileController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-purchase-order-file-controller
   * @name CreatePurchaseOrderFile
   * @request POST:/api/v1/purchase-requests/purchase-order/file
   */
  createPurchaseOrderFile = (data: CreatePoFilePurchaseRequest, params: RequestParams = {}) =>
    this.http.request<PurchaseRequestDto, any>({
      path: `/v1/purchase-requests/purchase-order/file`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createPurchaseOrderFilePath = '/v1/purchase-requests/purchase-order/file'
  static createPurchaseOrderFileMethod = 'POST'
}
